
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g64C6ARv4jFwjyZAmNSMCeCT_FvX5fv4GEc5CVwwwXaMMeta } from "/codebuild/output/src657077444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index_q604mJACamFNx4LmJh4bV_45ig1D0IMIJ_45XtP89u6CqgMeta } from "/codebuild/output/src657077444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchvhSBDvKgRdIPa1PeNUbB_oWHt9kwd5dTSRU5GzP8ovkMeta } from "/codebuild/output/src657077444/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexEEdC6uhJ7GZh5LV1mU0hh4Ws8rbdSH5Npu_T1FeWA1MMeta } from "/codebuild/output/src657077444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93Qz6gvNwN3dTynptoDysPQ38bA6pZymv_45tczpqKILcT8Meta } from "/codebuild/output/src657077444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexFN6nqKXqR12UmNk01_4545QVn_45FY6yxSQ_53G4BHNYoNwMeta } from "/codebuild/output/src657077444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93MI0FgEU2_9JyG30JRxERk7maDN1ikeVAm8BehXraNlIMeta } from "/codebuild/output/src657077444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexao_TVTbOTg7oNDM72sGMqGrbFRU9dlJrwNmikiK6FS0Meta } from "/codebuild/output/src657077444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93bmxSrgG9wnzyHFmZRkVHsemyMdArlKbYrZTHVOqa6zsMeta } from "/codebuild/output/src657077444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexSkjUXSH4fY3GyCfaNvodjDuS13WlMoyagJXW8Qj8I3QMeta } from "/codebuild/output/src657077444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexSCaM5KmV9HrSLWtdrpLuv2AG1UoGHl_457IYetMIIT6pkMeta } from "/codebuild/output/src657077444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src657077444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src657077444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src657077444/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src657077444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src657077444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexFN6nqKXqR12UmNk01_4545QVn_45FY6yxSQ_53G4BHNYoNwMeta || {},
    component: () => import("/codebuild/output/src657077444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src657077444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexao_TVTbOTg7oNDM72sGMqGrbFRU9dlJrwNmikiK6FS0Meta || {},
    component: () => import("/codebuild/output/src657077444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src657077444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexSkjUXSH4fY3GyCfaNvodjDuS13WlMoyagJXW8Qj8I3QMeta || {},
    component: () => import("/codebuild/output/src657077444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexSCaM5KmV9HrSLWtdrpLuv2AG1UoGHl_457IYetMIIT6pkMeta || {},
    component: () => import("/codebuild/output/src657077444/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]